export default class Gtag {
  constructor() {
    if (window.Cookies.get('3rd_party_consent')) {
      return;
    }
    window.dataLayer = window.dataLayer || [];
    this.analytics();
    this.ecommerce();
  }

  push() {
    window.dataLayer.push(arguments);
  }

  analytics() {
    this.push('js', new Date());
    this.push(
      'config',
      document.head.querySelector('meta[name="gtag-id"]').content
    );
  }

  ecommerce() {
    let data = document.head.querySelector('meta[name="ecommerce-data"]')
      .content;
    if (!data) {
      return;
    }
    this.push(JSON.parse(data));
  }
}
